<div class="togglebtn" *ngIf="userName !== 'Zeronorth ZN'">
  <mat-slide-toggle [checked]="mapViewVisible" (change)="toggleMapView()">
    {{ mapViewVisible ? "Table View" : "Beta Map View" }}</mat-slide-toggle
  >
  <div class="legend" *ngIf="mapViewVisible">
    <span class="legend-item">
      <span class="legend-color green"></span>Laden
    </span>
    <span class="legend-item">
      <span class="legend-color blue"></span>Ballast
    </span>
  </div>
</div>
<div class="text-right" *ngIf="userName === 'Zeronorth ZN'">
  <button class="btn btn-light hover-button apply refresh" (click)="refresh()">
    <mat-icon>refresh</mat-icon>
    <span class="name">Refresh</span>
  </button>
</div>
<div class="container" *ngIf="!mapViewVisible">
  <br />
  <app-expansion-panel [titleText]="'Table Filter'">
    <div class="filter" [ngClass]="{ 'dark-filter': isDarkMode() }">
      <form [formGroup]="updateForm">
        <div class="row">
          <div class="col">
            <app-custom-date-picker
              [label]="'From Date:'"
              [controlname]="this.updateForm.controls['from_date']"
            ></app-custom-date-picker>
          </div>
          <div class="col">
            <app-custom-date-picker
              [label]="'To Date:'"
              [controlname]="this.updateForm.controls['to_date']"
            ></app-custom-date-picker>
          </div>
          <div class="col">
            <app-custom-dropdown
              [placeholder]="'ALL'"
              [label]="'Segment:'"
              [items]="segmentOptions"
              [controlname]="this.updateForm.controls['segment']"
            ></app-custom-dropdown>
          </div>
          <div class="col">
            <app-custom-dropdown
              [placeholder]="'ALL'"
              [label]="'Condition:'"
              [items]="condition"
              [controlname]="this.updateForm.controls['condition']"
            ></app-custom-dropdown>
          </div>
          <div class="col">

            <label
              class="shipNameLabel"
              [ngClass]="{ 'dark-label': isDarkMode() }"
              >Ship Name</label
            >
            <input
              type="text"
              class="form-control shipName"
              id="shipName"
              formControlName="shipName"
              (input)="filterShipNames($event)"
              [matAutocomplete]="autoShip"
            />
            <mat-autocomplete #autoShip="matAutocomplete">
              <mat-option
                *ngFor="let ship of shipNameSuggestions"
                [value]="ship.ship"
              >
                {{ ship.ship }}
              </mat-option>
            </mat-autocomplete>
          </div>
          <div class="filterBtn">
            <button
              class="btn btn-light hover-button apply"
              (click)="clearClick()"
            >
              <mat-icon>clear_all</mat-icon>
              <span class="name">Clear Filter</span>
            </button>
          </div>
          <div class="filterBtn">
            <button
              class="btn btn-light hover-button apply"
              (click)="filterClick()"
            >
              <mat-icon class="filterIcon">filter_list</mat-icon>
              <span class="name">Apply Filter</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </app-expansion-panel>
  <div class="text-right" *ngIf="userName !== 'Elite Shipping'">
    <button
      class="btn btn-light hover-button apply"
      (click)="addRow()"
      [ngClass]="{
        add: userName === 'Meraki - Operations',
        'add-one': userName === 'Eiger Shipping'
      }"
    >
      <mat-icon>{{
        userName === "Meraki - Operations" ? "add" : "edit"
      }}</mat-icon>
      <span class="name">
        {{ userName === "Meraki - Operations" ? "Add Row" : "Edit Row" }}
      </span>
    </button>
    <button
      class="btn btn-light hover-button apply delete"
      (click)="deleteRow()"
      *ngIf="userName === 'Meraki - Operations'"
    >
      <mat-icon>delete</mat-icon>
      <span class="name">Delete Row</span>
    </button>

    <button
      class="btn btn-light hover-button apply"
      *ngIf="addRowdData.length > 0"
      (click)="saveData()"
    >
      <mat-icon>done</mat-icon>
      <span class="name">Save</span>
    </button>
    <button
      class="btn btn-light hover-button apply refresh"
      (click)="refresh()"
      *ngIf="!mapViewVisible"
    >
      <mat-icon>refresh</mat-icon>
      <span class="name">Refresh</span>
    </button>
  </div>
  <div
    class="scroll-bar"
    [ngClass]="{
      'table-container': userName === 'Meraki - Operations',
      'table-container-one': userName !== 'Meraki - Operations'
    }"
  >
    <table
      class="mat-elevation-z8"
      id="style-4"
      matSort
      [ngClass]="{ 'dark-table': isDarkMode() }"
    >
      <thead class="fixed-header">
        <tr>
          <th rowspan="2">S.No</th>
          <th mat-sort-header="ship" class="th-text-center3" rowspan="2">
            Ship Name
          </th>
          <th rowspan="2" *ngIf="userName !== 'Eiger Shipping'">Customer</th>
          <th rowspan="2" mat-sort-header="segment" class="th-text-center3">
            Segment
          </th>
          <th colspan="2" *ngIf="userName === 'Meraki - Operations'">Pic</th>
          <th rowspan="2" *ngIf="userName === 'Elite Shipping'">Meraki Pic</th>
          <th
            rowspan="2"
            *ngIf="userName === 'Eiger Shipping'"
            mat-sort-header="eigerpic"
            class="th-text-center3"
          >
            North Well Pic
          </th>
          <th colspan="2">Ports</th>
          <th rowspan="2" mat-sort-header="etaDate" class="th-text-center3">
            ETA(UTC)
          </th>
          <th rowspan="2" mat-sort-header="voyageType" class="th-text-center3">
            Condition
          </th>
          <th
            rowspan="2"
            mat-sort-header="cpOrderedSpeed"
            class="th-text-center3"
          >
            CP Speed
          </th>
          <th rowspan="2" mat-sort-header="claimable" class="th-text-center3">
            CP Speed Agreed
          </th>
          <th
            rowspan="2"
            *ngIf="userName !== 'Zeronorth ZN'"
            mat-sort-header="voyAvgSpeed"
            class="th-text-center3"
          >
            Avg Speed(Voy)
          </th>
          <th
            rowspan="2"
            mat-sort-header="flag"
            class="th-text-center3"
            *ngIf="userName === 'Meraki - Operations'"
          >
            Flag
          </th>
          <th rowspan="2" *ngIf="userName !== 'Zeronorth ZN'">Latitude</th>
          <th rowspan="2" *ngIf="userName !== 'Zeronorth ZN'">Longitude</th>
          <th rowspan="2" mat-sort-header="updatedAt" class="th-text-center3">
            Time Updated(UTC)
          </th>
          <th rowspan="2">Remarks</th>
          <th rowspan="2" *ngIf="userName === 'Meraki - Operations'">Edit</th>
        </tr>
        <tr>
          <th
            mat-sort-header="merakiPic"
            class="th-text-center2"
            *ngIf="userName === 'Meraki - Operations'"
          >
            Meraki
          </th>
          <th
            *ngIf="userName === 'Meraki - Operations'"
            mat-sort-header="eigerpic"
            class="th-text-center2"
          >
            Eiger
          </th>
          <th class="th-text-center" mat-sort-header="pFrom">
            <span>From</span>
          </th>
          <th class="th-text-center1" mat-sort-header="pTo"><span>To</span></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let element of addRowdData; let rowIndex = index">
          <td>
            <input
              type="checkbox"
              class="checkBox"
              [(ngModel)]="element.selected"
            />{{ element.sNo + rowIndex }}
          </td>
          <td>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="element.ship"
            />
          </td>
          <td *ngIf="userName !== 'Eiger Shipping'">
            <input
              type="text"
              class="form-control"
              [matAutocomplete]="auto"
              [(ngModel)]="element.customername"
              (input)="filterCustomerNames($event)"
            />
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option
                *ngFor="let suggestion of customerOptions"
                [value]="suggestion"
              >
                {{ suggestion }}
              </mat-option>
            </mat-autocomplete>
          </td>
          <td>
            <select [(ngModel)]="element.segment" class="form-control">
              <option
                *ngFor="
                  let item of segmentOptions;
                  even as isEven;
                  odd as isOdd
                "
                [value]="item"
                [ngClass]="{ odd: isOdd, even: isEven }"
              >
                {{ item }}
              </option>
            </select>
          </td>
          <td>
            <select [(ngModel)]="element.merakiPic" class="form-control">
              <option
                *ngFor="
                  let item of MerakiPicOptions;
                  even as isEven;
                  odd as isOdd
                "
                [value]="item"
                [ngClass]="{ odd: isOdd, even: isEven }"
              >
                {{ item }}
              </option>
            </select>
          </td>
          <td>
            <select [(ngModel)]="element.eigerPic" class="form-control">
              <option
                *ngFor="
                  let item of eigerPicOptions;
                  even as isEven;
                  odd as isOdd
                "
                [value]="item"
                [ngClass]="{ odd: isOdd, even: isEven }"
              >
                {{ item }}
              </option>
            </select>
          </td>
          <td>
            <input
              type="text"
              class="form-control"
              [matAutocomplete]="fauto"
              [(ngModel)]="element.pFrom"
              (input)="filterPortNames($event)"
            />
            <mat-autocomplete #fauto="matAutocomplete">
              <mat-option
                *ngFor="let fPortName of portNameSuggestions"
                [value]="fPortName.port_name"
              >
                {{ fPortName.port_name }}
              </mat-option>
            </mat-autocomplete>
          </td>
          <td>
            <input
              type="text"
              class="form-control"
              [matAutocomplete]="tauto"
              [(ngModel)]="element.pTo"
              (input)="filterPortNames($event)"
            />
            <mat-autocomplete #tauto="matAutocomplete">
              <mat-option
                *ngFor="let tPortName of portNameSuggestions"
                [value]="tPortName.port_name"
              >
                {{ tPortName.port_name }}
              </mat-option>
            </mat-autocomplete>
          </td>
          <td>
            <input
              type="date"
              class="form-control"
              [(ngModel)]="element.etaDate"
            />
          </td>
          <td>
            <div class="time-picker">
              <input
                placeholder="HH"
                type="number"
                id="hour"
                class="form-control time"
                [(ngModel)]="element.etaHours"
                min="0"
                max="24"
                (input)="restrictInput($event.target, 24)"
              />
              <span class="text"> :</span>
              <input
                placeholder="MM"
                type="number"
                id="minute"
                class="form-control time"
                [(ngModel)]="element.etaMinutes"
                min="0"
                max="59"
                (input)="restrictInput($event.target, 59)"
              />
            </div>
          </td>
          <td>
            <select [(ngModel)]="element.voyageType" class="form-control">
              <option
                *ngFor="let item of items; even as isEven; odd as isOdd"
                [value]="item"
                [ngClass]="{ odd: isOdd, even: isEven }"
              >
                {{ item }}
              </option>
            </select>
          </td>
          <td>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="element.cpOrderedSpeed"
            />
          </td>
          <td></td>
          <td>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="element.voyAvgSpeed"
            />
          </td>
          <td></td>
          <td>
            <input type="text" class="form-control" [(ngModel)]="element.lat" />
          </td>
          <td>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="element.long"
            />
          </td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr *ngFor="let element of paginatedData; let rowIndex = index">
          <td
            [ngStyle]="{
              padding: userName !== 'Meraki - Operations' ? '15px' : ''
            }"
          >
            <input
              *ngIf="userName === 'Meraki - Operations' || eigerUser"
              [disabled]="isRowSnoozed(element)"
              type="checkbox"
              class="checkBox"
              [(ngModel)]="element.selected"
              (click)="selectRow(element)"
            />{{ rowIndex + 1 }}
          </td>
          <td
            [ngClass]="{ 'red-text': isMoreThan30HoursOld(element.updatedAt) }"
          >
            {{ element.ship }}
          </td>
          <td *ngIf="userName !== 'Eiger Shipping'">
            {{ element.customername }}
          </td>
          <td>
            <span [ngStyle]="getDynamicSegmentStyle(element.segment)">
              {{ element.segment }}
            </span>
          </td>
          <td *ngIf="userName !== 'Eiger Shipping'">{{ element.merakiPic }}</td>
          <td *ngIf="userName === 'Meraki - Operations'">
            <ng-container *ngIf="element.selected; else eigerPicText">
              <select
                [(ngModel)]="element.eigerpic"
                class="form-control eigerPicUser"
                (ngModelChange)="onPicChange(element)"
              >
                <option *ngFor="let pic of eigerPicOptions" [value]="pic">
                  {{ pic }}
                </option>
              </select>
            </ng-container>
            <ng-template #eigerPicText>
              {{ element.eigerpic }}
            </ng-template>
          </td>
          <td *ngIf="userName === 'Eiger Shipping'">{{ element.eigerpic }}</td>
          <td>{{ element.pFrom }}</td>
          <td>{{ element.pTo }}</td>
          <td>
            {{ element.etaDate }}
          </td>
          <!-- <td>
            {{ formatTime(element.etaDate) }}
          </td> -->
          <td>{{ element.voyageType }}</td>
          <td>{{ element.cpOrderedSpeed }}</td>
          <td>{{ element.claimable === "Yes" ? "No" : "Yes" }}</td>
          <td *ngIf="userName !== 'Zeronorth ZN'">{{ element.voyAvgSpeed }}</td>
          <td
            [ngClass]="{
              'red-flag': element.flag === 'Red Flag',
              'gray-flag': element.flag === 'Gray Flag',
              'no-flag': element.flag === 'No Flag'
            }"
            *ngIf="userName === 'Meraki - Operations'"
          >
            {{ element.flag }}
          </td>
          <td *ngIf="userName !== 'Zeronorth ZN'">
            {{ convertToDegreeDirection(element.lat, true) }}
          </td>
          <td *ngIf="userName !== 'Zeronorth ZN'">
            {{ convertToDegreeDirection(element.long, false) }}
          </td>
          <td
            [ngClass]="{ 'red-text': isMoreThan30HoursOld(element.updatedAt) }"
          >
            {{ convertToUTC(element.updatedAt) }}
          </td>
          <td matTooltip="{{ element.additionalComments }}">
            {{
              element.additionalComments?.length > 10
                ? (element.additionalComments | slice : 0 : 10) + "..."
                : element.additionalComments
            }}
          </td>
          <td *ngIf="userName === 'Meraki - Operations'">
            <button
              class="downloadIcon"
              [disabled]="isRowSnoozed(element)"
              (click)="editRow(element)"
            >
              <mat-icon>edit</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <mat-paginator
    [length]="tableData.length"
    [pageSizeOptions]="[100]"
    [pageSize]="itemsPerPage"
    (page)="onPageChange($event)"
    [ngClass]="{ 'dark-paginator': isDarkMode() }"
    showFirstLastButtons
  ></mat-paginator>
  <div class="text-right" *ngIf="userName === 'Meraki - Operations'">
    <button class="btn btn-light hover-button apply" (click)="addRow()">
      <mat-icon>add</mat-icon>
      <span class="name">Add Row</span>
    </button>
    <button class="btn btn-light hover-button apply" (click)="deleteRow()">
      <mat-icon>delete</mat-icon>
      <span class="name">Delete Row</span>
    </button>
    <button
      class="btn btn-light hover-button apply"
      (click)="snoozeSelectedRow()"
      [disabled]="!isAnyRowSelected()"
    >
      <mat-icon>pause</mat-icon>
      <span class="name">Snooze Row</span>
    </button>
    <button
      class="btn btn-light hover-button apply"
      *ngIf="addRowdData.length > 0"
      (click)="saveData()"
    >
      <mat-icon>done</mat-icon>
      <span class="name">Save</span>
    </button>
    <button class="btn btn-light hover-button apply" (click)="exportClick()">
      <mat-icon>download</mat-icon>
      <span class="name"> Export</span>
    </button>
  </div>
</div>

<div class="mapView" *ngIf="mapViewVisible">
  <div class="screenshot-icon-container">
    <button
      mat-icon-button
      color="primary"
      matTooltip="Take Screenshot"
      (click)="captureScreenshot()"
    >
      <mat-icon>photo_camera</mat-icon>
    </button>
  </div>
  <app-map-view></app-map-view>
</div>
